import { Badge, Flex, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"

const EmployeeSalaryOvertimeTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">{t('expense.expense-detail.request-id')}</div>,
      dataIndex: "sequence",
      key: "sequence",
      render: (_, record) => {
        return <span style={{ backgroundColor: "#F5F6F7", paddingRight: "8px", paddingLeft: "8px", borderRadius: "50px" }}>{record?.sequence ? record?.sequence : "-"}</span>;
      },
      align: "center",
      width: "130px"
    },
    {
      title: <div className="text-table">{t('my_request.label.create-date')}</div>,
      dataIndex: "otDate",
      key: "otDate",
      render: (_, record) => {
        return <span>{dayjs(record?.startDateTime).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")}</span>
      }
    },
    {
      title: <div className="text-table">{t('shift.header')}</div>,
      dataIndex: "shiftName",
      key: "shiftName",
      align: "center",
      render: (_, record) => {
        return <Flex vertical align="center">
          <span>{i18n.language === "en" ? record?.shift?.shiftNameEn : record?.shift?.shiftName}</span>
          <span style={{ color: "#667085" }}>{i18n.language === "en"
            ? `${dayjs(record?.shift?.workTimeStart, "HH:mm:ss").format("HH:mm")} - ${dayjs(record?.shift?.workTimeEnd, "HH:mm:ss").format("HH:mm")}`
            : `${dayjs(record?.shift?.workTimeStart, "HH:mm:ss").format("HH:mm")} น. ถึง ${dayjs(record?.shift?.workTimeEnd, "HH:mm:ss").format("HH:mm")} น.`}</span>
        </Flex>
      }
    },
    {
      title: <div className="text-table">{t('leave_type.label.start-time')}</div>,
      dataIndex: "startTime",
      key: "startTime",
      render: (_, record) => {
        return <span>{i18n.language === "en" ? `${dayjs(record?.startDateTime).format("HH:mm")}` : `${dayjs(record?.startDateTime).format("HH:mm")} น.`}</span>
      }
    },
    {
      title: <div className="text-table">{t('leave_type.label.end-time')}</div>,
      dataIndex: "endTime",
      key: "endTime",
      align: "center",
      render: (_, record) => {
        const startDate = dayjs(record?.startDateTime).startOf("day");
        const endDate = dayjs(record?.endDateTime).startOf("day");

        const isDifferentDay = !startDate.isSame(endDate, "day");

        return <Flex vertical align="center">
          <span>{i18n.language === "en" ? `${dayjs(record?.endDateTime).format("HH:mm")}` : `${dayjs(record?.endDateTime).format("HH:mm")} น.`}</span>
          {isDifferentDay && (
            <span>({dayjs(record?.endDateTime).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")})</span>
          )}
        </Flex>
      }
    },
    {
      title: <div className="text-table">{t('workin.ot_report')}</div>,
      dataIndex: "otAmount",
      key: "otAmount",
      render: (_, record) => {
        const totalCal = record?.totalCal || 0;

        const formattedTime = `${(totalCal / 60).toFixed(2)} ${t("unit.hours")}`;

        return record?.isFixRate === "Y" ? `${formattedTime} × ${record?.otFixRate}` : `${formattedTime} × ${record?.otMultiplyRate}`
      }
    },
    {
      title: <div className="text-table">{t('ot.payment_status')}</div>,
      dataIndex: "paidStatus",
      key: "paidStatus",
      render: (_, record) => {
        let language = i18n.language == 'en' ? "En" : "Th"

        const statusMap = {
          PENDING: { text: record?.["paidStatus" + language], color: "#FFA726", background: "#FFF5E9" },
          PAID: { text: record?.["paidStatus" + language], color: "#00BA34", background: "#E6F9EB" }
        };

        const status = statusMap[record.paidStatus] || "-";

        return (
          <Badge
            color={status.color}
            style={{
              backgroundColor: status.background,
              borderRadius: "16px",
              padding: "2px 8px",
              fontSize: "0.8rem",
              color: status.color
            }}
            text={status.text}
          />
        );
      }
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeSalaryOvertimeTable;
